import { Component, Input, OnDestroy, OnInit, } from '@angular/core';
import { ControlContainer, UntypedFormGroup, FormGroupDirective, UntypedFormBuilder } from '@angular/forms';
import { TankatableBasicInfo } from 'sg-api';

/**単価表登録画面 （基本情報）
 * @export
 * @class Sgkc012dTankaTableBasicInfoComponent
 * @implements {OnInit,OnDestroy} 
 */
@Component({
    selector: 'app-sgkc012d-tanka-table-basic-info',
    templateUrl: './sgkc012d-tanka-table-basic-info.component.html',
    styleUrl: './sgkc012d-tanka-table-basic-info.component.scss',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkc012dTankaTableBasicInfoComponent implements OnInit, OnDestroy {
    /** 画面表示モード */
    @Input() mode: string
    /** 単価表基本情報 */
    @Input() tankatableBasicInfo: TankatableBasicInfo;

    /** 単価表名称 */
    tankatableAname = this.fb.control({ value: '', disabled: true });
    /** 単価表説明 */
    tankatableExplanation = this.fb.control({ value: '', disabled: true });
    /** 単価表コード */
    tankatableCode = this.fb.control({ value: '', disabled: true });
    /** 会社名 */
    companyname = this.fb.control({ value: '', disabled: true });
    /** エネルギー種別名称 */
    energyClsname = this.fb.control({ value: '', disabled: true });
    /** ＬＰ販売形態名称 */
    lpSalfrmAname = this.fb.control({ value: '', disabled: true });
    /** 地点群供給地点区分名称 */
    locationgroupSuppntDivisionname = this.fb.control({ value: '', disabled: true });
    /** プロダクト正式名 */
    prdAname = this.fb.control({ value: '', disabled: true });
    /** スライド調整単価名称 */
    slideadjustmentunitpriceAname = this.fb.control({ value: '', disabled: true });
    /** 単価表メモ */
    tankatableMemo = this.fb.control({ value: '', disabled: true });
    /** 単価基本情報保持Form */
    tankatableBasicInfoForm: UntypedFormGroup = this.fb.group({
        tankatableAname: this.tankatableAname,
        tankatableExplanation: this.tankatableExplanation,
        tankatableCode: this.tankatableCode,
        companyname: this.companyname,
        energyClsname: this.energyClsname,
        lpSalfrmAname: this.lpSalfrmAname,
        locationgroupSuppntDivisionname: this.locationgroupSuppntDivisionname,
        prdAname: this.prdAname,
        slideadjustmentunitpriceAname: this.slideadjustmentunitpriceAname,
        tankatableMemo: this.tankatableMemo
    });
    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;

    /** 
     * コンストラクタ
     * @param {FormGroupDirective} parent
     * @param {UntypedFormBuilder} fb
     * @memberof Sgkc012dTankaTableBasicInfoComponent
     */
    constructor(
        private parent: FormGroupDirective,
        private fb: UntypedFormBuilder,) {
    }

    /** 
     * 初期処理
     * @memberof Sgkc012dTankaTableBasicInfoComponent
     */
    ngOnInit(): void {
        this.parentForm = this.parent.form;
        this.parentForm.addControl('tankatableBasicInfoForm', this.tankatableBasicInfoForm);
        // 単価表基本情報FormGroupに初期値を設定
        this.tankatableBasicInfoForm.controls['tankatableAname'].setValue(this.tankatableBasicInfo.tankatableAname);
        this.tankatableBasicInfoForm.controls['tankatableExplanation'].setValue(this.tankatableBasicInfo.tankatableExplanation);
        this.tankatableBasicInfoForm.controls['tankatableCode'].setValue(this.tankatableBasicInfo.tankatableCode);
        this.tankatableBasicInfoForm.controls['companyname'].setValue(this.tankatableBasicInfo.companyname);
        this.tankatableBasicInfoForm.controls['energyClsname'].setValue(this.tankatableBasicInfo.energyClsname);
        this.tankatableBasicInfoForm.controls['lpSalfrmAname'].setValue(this.tankatableBasicInfo.lpSalfrmAname);
        this.tankatableBasicInfoForm.controls['locationgroupSuppntDivisionname'].setValue(this.tankatableBasicInfo.locationgroupSuppntDivisionname);
        this.tankatableBasicInfoForm.controls['prdAname'].setValue(this.tankatableBasicInfo.prdAname);
        this.tankatableBasicInfoForm.controls['slideadjustmentunitpriceAname'].setValue(this.tankatableBasicInfo.slideadjustmentunitpriceAname);
        this.tankatableBasicInfoForm.controls['tankatableMemo'].setValue(this.tankatableBasicInfo.tankatableMemo);
    }

    /** 
     * 変更を停止する処理
     * @memberof Sgkc012dTankaTableBasicInfoComponent
     */
    ngOnDestroy(): void {
        this.parentForm.clearValidators();
        this.parentForm.updateValueAndValidity();
        this.parentForm.removeControl('tankatableBasicInfoForm');
    }
}
